import { Component } from "react";

/**
 * Catches a render throw anywhere in its subtree so it replaces just that
 * subtree with `fallback` instead of unmounting the whole app (React 18's
 * default behaviour for an uncaught render error). Reports the error to the
 * console rather than swallowing it silently.
 */
class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error(error, info);
  }

  render() {
    if (this.state.hasError) return this.props.fallback ?? null;
    return this.props.children;
  }
}

export default ErrorBoundary;
